module.exports = __webpack_public_path__ + "static/media/DSC_0199 (2).a8bc2d5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0199 (2).jpg
// module id = 644
// module chunks = 0